const formatValue = (value) => {
  return (value || "Not set").replaceAll("_", " ");
};

export default function OfficialStatusBadge({ label, state, testId }) {
  return (
    <span
      className={`official-status-badge state-${state || "neutral"}`}
      data-testid={testId}
      title={`Official calculated state: ${formatValue(state)}`}
    >
      {label || "Not set"}
    </span>
  );
}
